<template>
    <content-wrapper>
        <Content class="mt-3">
            <b-card header-bg-variant="dark">
                <template #header>
                    <b-row class="align-items-center justify-content-between text-nowrap">
                        <b-col>
                            <h6 class="mb-0">MayDay</h6>
                        </b-col>
                        <b-col md="2">
                            <!-- Hidden -->
                            <!-- <div class="d-flex justify-content-end">
                                <b-button variant="outline-light" @click.prevent="openAutoRetryModal()">
                                    <b-icon icon="plus-circle-fill"></b-icon>&nbsp;&nbsp;
                                    Auto
                                </b-button>
                            </div> -->
                        </b-col>
                    </b-row>
                </template>
                
                <b-row class="mb-3 align-items-stretch">
                    <b-col md="3">
                        <b-form-input class="text-center" id="total-records" :value="totalRecords" disabled></b-form-input>
                    </b-col>
                </b-row>

                <!-- Contingency Table -->
                <b-table ref="table"
                    id="table"
                    :per-page="pagination.per_page"
                    :current-page="pagination.current_page"
                    :items="loadPage"
                    :fields="columns"
                    :busy.sync="isLoading"
                    striped
                    borderless
                    outlined
                    hover
                    show-empty
                    empty-text="No records found..."
                    stacked="sm"
                    class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-primary my-2">
                        <b-spinner label="Loading..." type="grow"></b-spinner>
                        </div>
                    </template>

                    <!-- table custom content -->
                    <template #cell(no_pol)="data">
                        <span v-if="data.item.no_pol">{{ data.item.no_pol }}</span>
                        <span v-else class="text-danger text-center"><i>Auto</i></span>
                    </template>
                    <template #cell(container)="data">
                        <span v-if="cleanedContainers(data.item).length > 0" >
                            <span 
                               v-for="(con, idx) in cleanedContainers(data.item)" 
                                :key="`${con}-${idx}`">
                                <span class="px-1 bg-warning text-center font-weight-bold">{{ con }}</span>&nbsp;
                            </span>
                        </span>
                        <span v-else class="text-danger text-center"><i>Auto</i></span>
                    </template>
                    <template #cell(direction)="data">
                        <span v-if="data.item.direction === 1">
                            <b>in</b>
                        </span>
                        <span v-else-if="data.item.direction === 2">
                            <b>out</b>
                        </span>
                        <span v-else>-</span>
                    </template>
                    <template #cell(status)="data">
                        <span v-if="data.item.status === 0">
                            <span class="text-danger font-weight-bold">Open</span>
                        </span>
                        <span v-else-if="data.item.status === 1">
                            <span class="text-success font-weight-bold">Executed</span>
                        </span>
                        <span v-else>-</span>
                    </template>
                    <template #cell(updated_at)="data">
                        {{ formatTanggal(data.item.updated_at) }}
                    </template>
                    <template #cell(action)="data">
                        <b-button squared variant="info" class="flex-grow-1 btn-sm text-nowrap" @click="showQRModal(data.item)">
                            &nbsp;QR Code&nbsp;
                        </b-button>
                    </template>
                </b-table>

                <!-- pagination -->
                <div class="d-flex justify-content-center">
                    <laravel-pagination
                        :pagination="pagination"
                        @change="changePage"
                        />
                </div>
            </b-card>
        </Content>

        <b-modal
            header-bg-variant="success"
            :title="singleQRShow.title"
            v-model="detailModal"
            id="detail"
            ref="autoRetryModal"
            hide-header-close
            centered
            ok-only
            ok-title="Close"
            ok-variant="secondary"
            >

            <h4 class="text-center text-bold text-uppercase">
                {{ singleQRShow.company_name }}
            </h4>
            <h2 class="text-center">
                {{ singleQRShow.date.replace(/\+.*/, '') }}
            </h2>
            <h1 class="text-center text-uppercase text-bold">
                {{ singleQRShow.direction }}
            </h1>

            <!-- QR-CODE -->
            <b-img class="border" :src="`static/qrcode/${singleQRShow.qrcode}`" fluid center></b-img>

            <h1 class="text-center text-bold text-uppercase">
                {{ singleQRShow.lic_plate }}
            </h1>
                <h2 class="text-center text-uppercase" v-if="singleQRShow.containers!==undefined">
                <ul class="list-group list-group-flush" v-if="singleQRShow.containers!==null">
                    <li
                        class="list-group-item"
                        v-for="(ctr, idx) in singleQRShow.containers"
                        :key="(ctr && ctr.container) ? ctr.container : idx"
                    >
                        {{ ctr === undefined || ctr === null ? '' : ( (ctr.container !== undefined && ctr.container !== null) ? ctr.container : ctr ) }}
                    </li>
                </ul>
            </h2>
            
        </b-modal>
    </content-wrapper>
</template>

<script>
import { listMayday, singleQR } from '@/services/mayday';
import LaravelPagination from "@/components/LaravelPagination";

export default {
    name: 'Mayday',
    components: {LaravelPagination},
    data() {
        return {
            isLoading: false,
            isBtnLoading: false,
            totalRecords: 'Total Records',
            detailModal: false,
            columns: [
                { key: 'id', label: 'ID'},
                { key: 'no_pol', label: 'No Pol'},
                { key: 'container', label: 'Container'},
                { key: 'direction', label: 'Direction'},
                { key: 'status', label: 'Status'},
                { 
                    key: 'updated_at', 
                    label: 'Time'
                },
                { key: 'action', label: 'Action'},
            ],
            pagination: { // Laravel pagination
                current_page: 1,
                first_page_url: '',
                from: 1,
                last_page: 1,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 10,
                prev_page_url: '',
                to: 10,
                total: 10,
            },
            filters: {},
            singleQRShow:{
                qrcode:'AGS',
                title:'QR Code Loading ..',
                company_name:'AGS',
                containers: null,
                lic_plate:'loading',
                date:'',
                direction:''
            }
        }
    },
    methods: {
        async loadPage() {
            this.isLoading = true;
            try {
                const payload = {
                    ...this.pagination,
                    ...this.filters,
                };
                const list_mayday = JSON.parse(await listMayday(payload)).data;
                console.log('list_mayday', list_mayday);
                this.totalRecords = 'Total Records : '+list_mayday.total;
                this.pagination = {
                    current_page: list_mayday.current_page,
                    first_page_url: list_mayday.first_page_url,
                    from: list_mayday.from,
                    last_page: list_mayday.last_page,
                    last_page_url: list_mayday.last_page_url,
                    links: list_mayday.links,
                    next_page_url: list_mayday.next_page_url,
                    path: list_mayday.path,
                    per_page: list_mayday.per_page,
                    prev_page_url: list_mayday.prev_page_url,
                    to: list_mayday.to,
                    total: list_mayday.total,
                };
                return list_mayday.data || [];
            } catch (error) {
                this.$bvToast.toast('Failed to load data.', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                });
                return [];
            } finally {
                this.isLoading = false;
            }
        },
        changePage(page) {
            this.pagination.current_page = page;
            this.$refs.table.refresh();
        },
        async showQRModal(item) {
            this.isBtnLoading = true;

            if ((item.qrcode || {}).length === 0) {
                this.$bvToast.toast(`QRCode does not exists`, {
                title: 'Error!',
                autoHideDelay: 1500,
                variant: 'danger',
                })
                this.isLoading = false;
                return;
            }
            
            const qrData = JSON.parse(await singleQR(item.qrcode));
            if(!qrData.data || qrData.status !== 'success' ){
                this.$bvToast.toast(`Failed to load QR Code data`, {
                    title: 'Error!',
                    autoHideDelay: 1500,
                    variant: 'danger',
                })
                this.isBtnLoading = false;
                return;
            }

            this.singleQRShow.qrcode = qrData.data.pass_code || 'AGS';
            // build a title from member company name and vehicle if available
            const memberName = (qrData.data.member && qrData.data.member.company_name) ? qrData.data.member.company_name : '';
            const vehicleName = qrData.data.vehicle || '';
            this.singleQRShow.title = (memberName || vehicleName) ? (memberName + (vehicleName ? ' - ' + vehicleName : '')) : 'QR Code';
            this.singleQRShow.company_name = (qrData.data.member && qrData.data.member.company_name) ? qrData.data.member.company_name : 'AGS';
            this.singleQRShow.containers = qrData.data.containers || null;
            this.singleQRShow.lic_plate = qrData.data.vehicle || 'no data';
            this.singleQRShow.date = qrData.data.permit_date || ''; 
            this.singleQRShow.direction = qrData.data.direction == 1 ? 'IN' : (qrData.data.direction == 2 ? 'OUT' : '');

            this.detailModal = true;
            this.isBtnLoading = false;
            // console.log('QR Code Data:', item.qrcode);
        },
        debug(value) {
            // dipanggil dari template untuk tujuan debugging
            console.log('container data.item.container', value);
            // kembalikan string kosong agar tidak menampilkan apapun di UI
            return '';
        },
        formatTanggal(datetime) {
            const date = new Date(datetime);
            const dd = String(date.getDate()).padStart(2, '0');
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const yyyy = date.getFullYear();

            const hh = String(date.getHours()).padStart(2, '0');
            const mi = String(date.getMinutes()).padStart(2, '0');
            const ss = String(date.getSeconds()).padStart(2, '0');

            return `${dd}-${mm}-${yyyy} ${hh}:${mi}:${ss}`;
        },
        cleanedContainers(row) {
            // Normalize container values to primitive strings so they can safely be
            // used as :key in v-for loops and displayed consistently.
            if (!row || row.container === undefined || row.container === null) {
                return [];
            }

            const list = Array.isArray(row.container)
                ? row.container
                : [row.container];

            // Map possible object entries to their string value (e.g. { container: 'ABC' })
            // then trim and filter out empty strings.
            return list
                .map(con => {
                    if (con === undefined || con === null) return '';
                    if (typeof con === 'object') {
                        // try common property names
                        const val = (con.container !== undefined && con.container !== null)
                            ? con.container
                            : (con.name !== undefined && con.name !== null ? con.name : '');
                        return String(val).trim();
                    }
                    return String(con).trim();
                })
                .filter(con => con !== '');
        }
    }
}
</script>